import Util from "utils/util";

export const triggerStoreViewed = ({
  store_id,
  store_name,
  store_location,
  terminal,
  sector,
  movement_type,
  params = {},
}) => {

  Util.triggerMoEngageEvent("kiosk_store_viewed", {
    store_id: store_id,
    store_name: store_name,
    store_location: store_location,
    terminal: terminal,
    sector: sector,
    movement_type: movement_type,
    ...params,
  });
};

export const triggerStoreMenuExpanded = ({
  store_id,
  store_name,
  store_location,
  section_name,
  terminal,
  movement_type,
  sector,
  params = {},
}) => {

  Util.triggerMoEngageEvent("kiosk_store_menu_expanded", {
    store_id: store_id,
    store_name: store_name,
    store_location: store_location,
    section_name: section_name,
    terminal: terminal,
    movement_type: movement_type,
    sector: sector,
    ...params,
  });
};

export const triggerProductViewed = ({
  item_id,
  item_name,
  item_price,
  store_name,
  store_id,
  preference_available,
  trigger_point,
  trigger_modal,
  domain,
  terminal,
  movement_type,
  sector,
  params = {},
}) => {

  Util.triggerMoEngageEvent("kiosk_product_viewed", {
    item_id: item_id,
    item_name: item_name,
    item_price: item_price,
    store_name: store_name,
    store_id: store_id,
    preference_available: preference_available,
    trigger_point: trigger_point,
    trigger_modal: trigger_modal,
    domain: domain,
    terminal: terminal,
    movement_type: movement_type,
    sector: sector,
    ...params,
  });
};

export const triggerAddToCart = ({
  item_id,
  item_name,
  item_price,
  item_count,
  item_size,
  store_name,
  store_id,
  movement_type,
  sector,
  terminal,
  domain,
  fulfilment_type,
  delivery_time,
  delivery_time_ms,
  preference_available,
  preference_selected,
  preference_price,
  trigger_point,
  params = {},
}) => {
  Util.triggerMoEngageEvent("kiosk_add_to_cart", {
    item_id,
    item_name,
    item_price,
    item_count,
    item_size,
    store_name,
    store_id,
    movement_type,
    sector,
    terminal,
    domain,
    fulfilment_type,
    delivery_time,
    delivery_time_ms,
    preference_available,
    preference_selected,
    preference_price,
    trigger_point,
    ...params,
  });
};

export const triggerProductUpdate = ({
  item_id,
  item_name,
  item_price,
  updated_quantity,
  type,
  store_name,
  store_id,
  movement_type,
  sector,
  terminal,
  domain,
  fulfilment_type,
  delivery_time,
  delivery_time_ms,
  preference_available,
  preference_selected,
  preference_price,
  trigger_point,
  params = {},
}) => {
  Util.triggerMoEngageEvent("kiosk_product_update", {
    item_id,
    item_name,
    item_price,
    updated_quantity,
    type,
    store_name,
    store_id,
    movement_type,
    sector,
    terminal,
    domain,
    fulfilment_type,
    delivery_time,
    delivery_time_ms,
    preference_available,
    preference_selected,
    preference_price,
    trigger_point,
    ...params,
  });
};

export const triggerCartViewed = ({
  item_id,
  item_name,
  item_price,
  item_count,
  item_size,
  store_name,
  store_id,
  movement_type,
  sector,
  terminal,
  domain,
  fulfilment_type,
  delivery_time,
  delivery_time_ms,
  preference_available,
  preference_selected,
  preference_price,
  trigger_point,
  sub_total,
  convenience_fee,
  taxes,
  total,
  params = {},
}) => {
  Util.triggerMoEngageEvent("kiosk_cart_viewed", {
    item_id,
    item_name,
    item_price,
    item_count,
    item_size,
    store_name,
    store_id,
    movement_type,
    sector,
    terminal,
    domain,
    fulfilment_type,
    delivery_time,
    delivery_time_ms,
    preference_available,
    preference_selected,
    preference_price,
    trigger_point,
    sub_total,
    convenience_fee,
    taxes,
    total,
    ...params,
  });
};

export const triggerProceedToPay = ({
  item_id,
  item_name,
  item_price,
  store_name,
  store_id,
  movement_type,
  sector,
  terminal,
  sub_total,
  discounts,
  convenience_fee,
  taxes,
  total,
  delivery_time,
  delivery_time_ms,
  preference_available,
  preference_selected,
  preference_price,
  trigger_point,
  params = {},
}) => {
  Util.triggerMoEngageEvent("kiosk_proceed_to_pay", {
    item_id,
    item_name,
    item_price,
    store_name,
    store_id,
    movement_type,
    sector,
    terminal,
    sub_total,
    discounts,
    convenience_fee,
    taxes,
    total,
    delivery_time,
    delivery_time_ms,
    preference_available,
    preference_selected,
    preference_price,
    trigger_point,
    ...params,
  });
};

export const triggerQuickSignIn = ({
  timestamp,
  UserId,
  name,
  type,
  lmsmemberid,
  params = {},
}) => {
  Util.triggerMoEngageEvent("kiosk_quick_sign_in", {
    timestamp,
    UserId,
    name,
    type,
    lmsmemberid,
    ...params,
  });
};

export const triggerPaymentSuccessful = ({
  order_id,
  store_name,
  store_id,
  item_name,
  item_id,
  item_quantity,
  item_price,
  movement_type,
  sector,
  terminal,
  total,
  sub_total,
  discount,
  taxes,
  packaging_charges,
  domain,
  delivery_time,
  delivery_time_ms,
  fulfilment_type,
  payment_mode,
  params = {},
}) => {
  Util.triggerMoEngageEvent("kiosk_payment_successful", {
    order_id,
    store_name,
    store_id,
    item_name,
    item_id,
    item_quantity,
    item_price,
    movement_type,
    sector,
    terminal,
    total,
    sub_total,
    discount,
    taxes,
    packaging_charges,
    domain,
    delivery_time,
    delivery_time_ms,
    fulfilment_type,
    payment_mode,
    ...params,
  });
};

export const triggerPaymentFailed = ({
  item_name,
  item_price,
  store_name,
  domain,
  movement,
  sector,
  terminal,
  pickup,
  drop,
  delivery_times,
  delivery_times_ms,
  total,
  sub_total,
  discount,
  taxes,
  packaging_charges,
  orderId,
  reason,
  params = {},
}) => {
  Util.triggerMoEngageEvent("kiosk_payment_failed", {
    item_name,
    item_price,
    store_name,
    domain,
    movement,
    sector,
    terminal,
    pickup,
    drop,
    delivery_times,
    delivery_times_ms,
    total,
    sub_total,
    discount,
    taxes,
    packaging_charges,
    orderId,
    reason,
    ...params,
  });
};

export const triggerFilterApplied = ({
  filter_value,
  domain,
  params = {},
}) => {
  Util.triggerMoEngageEvent("kiosk_filter_applied", {
    filter_value,
    domain,
    ...params,
  });
};